define 'controller/GkCategoryController', ['jquery'], ($) ->
  class GkCategoryController

    constructor: (@$el) ->
      @$self = @$el
      @_init()

    _init: ->
      extKey = @$el.attr("data-external-key")
      $.ajax
        url: '/api/gk/view/category?externalKey=' + extKey
        type: 'POST'
        xhrFields:
          showLoadingIndicator: false
        error : ->

